<template>
  <div class="search-results">
    <section class="section">
      <div class="search-results__list">
        <result-card v-for="item in results" :data="item" :key="item.id" :printing="item.printing" :expanded="item.expanded"/>
      </div>
    </section>
  </div>
</template>

<script>
import ResultCard from './partials/ResultCard';

export default {
  name: 'SearchResults',
  props: ['results', 'form-data'],
  components: {
    ResultCard
  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/variables";

.search-results {
  text-align: left;
  &__header {
    padding: 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    border-width: 2px;  
    border-style: solid;    
    border-radius: 5px;

    @media (max-width: 991px) {
      padding: 20px;
    }
    @media (max-width: 767px) {
      flex-direction: column;
    }
  }
  &__sort {
    display: flex;
    justify-content: flex-end;
    margin: 30px 0;
  }
  &__list {
    padding: 0 0 30px 0;
  }
  &__item {
    margin: 0 0 30px 0;
  }
  &__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 30px 0;
  }
  &__page {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-width: 2px;
    border-style: solid;  
    border-radius: 5px;
    font-family: $main-font;
    margin: 0 5px;
    transition: all 0.2s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResults.vue